import intl from 'react-intl-universal';

import { parseAreaMobileStr } from '@/components/BaseMobileInput/helper';

// 账户类型
export enum AccountType {
  EmployeeAccount = 1, // 员工账号
  SystemAccount = 2, // 系统账户
}

// 登录方式
export enum LoginType {
  DingTalk = 1, // 钉钉
  MobileCode = 2, // 手机验证码
  MobilePassword = 3, // 手机号密码
  AccountPassword = 4, // 用户名密码
}

// 登录方式
export enum LoginMethodEnum {
  PermissionDenied, // 没权限
  EmployeeDingTalkQRCode, // 钉钉扫码
  EmployeeMobileCode, // 员工账号 手机-验证码
  EmployeeMobilePassword, // 员工账号 手机-密码
  EmployeeAccountPassword, // 员工 账号-密码
  SystemMobileCode, // 系统账号 手机-验证码
  SystemMobilePassword, // 系统账号 手机-密码
}

// 员工登录方式
export const EmployeeTypeList = [
  {
    id: LoginMethodEnum.EmployeeDingTalkQRCode,
    name: intl.get('login_type_dingtalk_code'),
    icon: 'icon-dingdingdenglu',
    accountType: AccountType.EmployeeAccount,
    loginType: LoginType.DingTalk,
  },
  {
    id: LoginMethodEnum.EmployeeMobileCode,
    name: intl.get('login_type_mobile_code'),
    icon: 'icon-shoujiyanzhengma',
    accountType: AccountType.EmployeeAccount,
    loginType: LoginType.MobileCode,
  },
  {
    id: LoginMethodEnum.EmployeeMobilePassword,
    name: intl.get('login_type_mobile_password'),
    icon: 'icon-shoujihaomima',
    accountType: AccountType.EmployeeAccount,
    loginType: LoginType.MobilePassword,
  },
  {
    id: LoginMethodEnum.EmployeeAccountPassword,
    name: intl.get('login_type_account_password'),
    icon: 'icon-zhanghaomima',
    accountType: AccountType.EmployeeAccount,
    loginType: LoginType.AccountPassword,
  },
];

// 系统登录方式
export const SystemTypeList = [
  {
    id: LoginMethodEnum.SystemMobileCode,
    name: intl.get('login_type_mobile_code'),
    icon: 'icon-shoujiyanzhengma',
    accountType: AccountType.SystemAccount,
    loginType: LoginType.MobileCode,
  },
  {
    id: LoginMethodEnum.SystemMobilePassword,
    name: intl.get('login_type_mobile_password'),
    icon: 'icon-shoujihaomima',
    accountType: AccountType.SystemAccount,
    loginType: LoginType.MobilePassword,
  },
];

// 校验手机号
export const validateMobileValue = (val) => {
  const { areaCode, mobileStr } = parseAreaMobileStr(val);
  if (areaCode && mobileStr) return undefined;
  return intl.get('login_sms_msg2');
};
